export default "__VITE_ASSET__EWkF5UFK__"